import hBorder from './src/h-border'

hBorder.install = function (Vue) {
  Vue.component(hBorder.name, hBorder);
};

export default hBorder;